import React from 'react';
import PropTypes from 'prop-types';

export default class Waiting extends React.Component {

  static propTypes = {
    waitingText: PropTypes.string
  }

  static defaultProps = {
    waitingText: 'Crunching'
  }

  render() {
    return(
      <div className='waiting'>
        <span>Yakety</span> <span>Yak</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/waiting.jsx